import { Layout } from "containers/";
import {
  getPropertyDetail,
  getPropertyDetailImage,
  getPropertyDetailLocation,
} from "@services/property-shares";
import { Property } from "components/";
import NotFound from "components/NotFound";
const BASE_URL = process.env.API;

export async function getServerSideProps(context) {
  try {
    const getProperty = await getPropertyDetail(context.params.slug);

    const getImage = await getPropertyDetailImage(
      getProperty?.data?.property?.links?.property_images,
    );
    const getLocation = await getPropertyDetailLocation(
      getProperty?.data?.property?.links?.property_locations,
    );
    getImage.data.map(async (obj) => {
      if (obj.is_360) {
        obj.image.cors = `${BASE_URL}/service/proxy-images?url=${obj?.image?.url}`;
      }
    });
    return {
      props: {
        data: getProperty?.data || [],
        images: getImage?.data,
        location: getLocation?.data.find((val) => val.is_publish),
      },
    };
  } catch (error) {
    return {
      props: {
        data: [],
      },
    };
  }
}

const PropertyPage = ({ data, images, location }) => {
  if (data.length === 0) {
    return <NotFound />;
  }

  if (!data?.user?.is_active) {
    return (
      <div className="row no-gutters justify-content-center">
        <div className="col-12 col-sm-7 col-md-5 col-lg-4 col-xl-4">
          <div
            className="container no-gutters no-side-padding"
            style={{ background: "#fff", height: "100vh", display: "table" }}
          >
            <div
              className="row no-gutters justify-content-center"
              style={{ display: "table-cell", verticalAlign: "middle" }}
            >
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontSize: 35,
                    lineHeight: 1.3,
                    marginBottom: "1rem",
                  }}
                >
                  404
                </p>
                <img src="../../static/images/icons/one21/404ilustration.svg" />
                <p
                  style={{
                    fontSize: 30,
                    marginTop: "1rem",
                  }}
                >
                  User sudah tidak aktif
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Layout title="Listing Property Detail | One21">
      <Property data={data} images={images} location={location} />
    </Layout>
  );
};

export default PropertyPage;
